import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M12 8v8","key":"svg-1"}]]

const IconSquareLetterI = createReactComponent('outline', 'square-letter-i', 'SquareLetterI', __iconNode);

export default IconSquareLetterI;